import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function SubcategoryForm() {
  const [name, setName] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
  // Fetch categories
  fetch('https://agaram.ematixsolutions.com/api/categories')
    .then((res) => res.json())
    .then((data) => setCategories(data))
    .catch((err) => console.error('Error fetching categories:', err));

  // Fetch subcategory if editing
  if (id) {
    setIsEdit(true);
   fetch(`https://agaram.ematixsolutions.com/api/subcategories/${id}`)

      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched subcategory data:", data);

        // Support both { name: ..., category_id: ... } and { subcategory: { ... } }
        const sub = data.subcategory ?? data;

        setName(sub.name || '');
        setSelectedCategoryId(sub.category_id?.toString() || '');
        if (sub.image_url) setImageUrl(sub.image_url);
      })
      .catch((err) => {
        console.error('Error fetching subcategory:', err);
        alert('Failed to load subcategory');
      });
  }
}, [id]);


  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', name);
    formData.append('category_id', selectedCategoryId);
    if (imageFile) formData.append('image', imageFile);
    if (isEdit) formData.append('_method', 'PUT');
     console.log('Form Data:', formData);
    // Log form data for debugging
    try {
      const response = await fetch(`https://agaram.ematixsolutions.com/api/subcategories${isEdit ? `/${id}` : ''}`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(`✅ Subcategory ${isEdit ? 'updated' : 'added'} successfully!`);
        navigate('/dashboard');
      } else {
        alert(result.message || 'Something went wrong!');
      }
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  return (
    <div style={{
      maxWidth: '480px',
      margin: '80px auto',
      padding: '32px',
      borderRadius: '16px',
      boxShadow: '0 12px 24px hsla(0, 0.00%, 0.00%, 0.10)',
      backgroundColor: '#f2f2f2',
      fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    }}>
      <h2 style={{
        textAlign: 'center',
        color: '#006666',
        marginBottom: '24px',
        fontSize: '24px',
      }}>{isEdit ? 'Edit Subcategory' : 'Add Subcategory'}</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Subcategory Name"
          value={name}
          required
          onChange={(e) => setName(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            marginBottom: '16px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            fontSize: '16px',
          }}
        />

        <select
          value={selectedCategoryId}
          onChange={(e) => setSelectedCategoryId(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '12px',
            marginBottom: '16px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            fontSize: '16px',
          }}
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>

        {isEdit && imageUrl && !imageFile && (
          <div style={{ marginBottom: '16px' }}>
            <label>Current Image:</label>
            <br />
            <img
              src={imageUrl}
              alt="Subcategory"
              style={{
                width: '100px',
                height: '100px',
                objectFit: 'cover',
                borderRadius: '6px',
                border: '1px solid #ccc'
              }}
            />
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '8px',
            border: '1px solid #ccc'
          }}
        />

        <button type="submit" style={{
          width: '100%',
          padding: '12px',
          backgroundColor: 'blue',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '16px',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer'
        }}>
          {isEdit ? 'Update' : 'Add'} Subcategory
        </button>
      </form>
    </div>
  );
}

export default SubcategoryForm;
